// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__GHn2f","footer":"styles_footer__2ePlR"};